<template>

    <div>
        <div class="row">
            <div class="col-md-4 col-md-offset-4">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Gebruikers</h2>
                    </div>
                    <div class="box-body">
                        <div class="callout callout-danger" v-show="loading === false && !canAddUser">
                            <h4>Niet mogelijk om nieuwe gebruiker toe te voegen</h4>
                            <p>Het is momenteel niet mogelijk om nieuwe gebruikers toe te voegen, omdat het maximaal aantal gebruikers reeds bereikt is.</p>
                        </div>
                        <table class="table margin-bottom">
                            <tbody>
                                <tr>
                                    <th class="col-sm-6">Beschikbare gebruikers</th>
                                    <td>{{ stats.max }}</td>
                                </tr>
                                <tr>
                                    <th>Aantal gebruikers</th>
                                    <td>{{ stats.current }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-show="loading === false && (!canAddUser || exceedsLimit)">
                            <div class="callout callout-info">
                                <h4>Beschikbare gebruikers verhogen</h4>
                                <p>U kunt uw aantal beschikbare gebruikers verhogen door contact op te nemen met Archibase. Neem hiervoor contact met ons op via support@archibase.nl</p>
                            </div>
                        </div>
                    </div>
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-spin fa-refresh"></i>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="canAddUser" class="row">
            <div class="col-md-4">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Instellingen</h2>
                    </div>
                    <div class="box-body">
                        <div class="form-group">
                            <label for="locale">Taal*:</label>
                            <v-select id="locale"
                                :reduce="value => value.value"
                                :options="locales"
                                v-model="form.locale_id"
                            ></v-select>
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('username')}">
                            <label for="username">Gebruikersnaam*:</label>
                            <div class="input-group">
                                <input type="text" id="username" class="form-control" tabindex="1"
                                    :disabled="add !== true"
                                    v-model="form.username"
                                    @focus="clear('username')"
                                    @blur="check('username', $event)"
                                />
                                <span v-if="checked.indexOf('username') !== -1" class="input-group-addon successbg"><i class="mdi mdi-check"></i></span>
                                <span v-else-if="alerts.indexOf('username') !== -1" class="input-group-addon dangerbg" v-tooltip="'Er is een ongeldige waarde'"><i class="mdi mdi-alert-circle-outline"></i></span>
                                <span v-else class="input-group-addon" v-tooltip="'Te controleren'"><i class="mdi mdi-dots-horizontal"></i></span>
                            </div>
                            <span v-if="errors.has('username')" class="help-block">{{ errors.get('username') }}</span>
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('email')}">
                            <label for="email">E-mailadres (zakelijk)*:</label>
                            <div class="input-group">
                                <input type="text" id="email" class="form-control" tabindex="1"
                                    :disabled="add !== true"
                                    v-model="form.email"
                                    @focus="clear('email')"
                                    @blur="check('email', $event)"
                                />
                                <span v-if="checked.indexOf('email') !== -1" class="input-group-addon successbg"><i class="mdi mdi-check"></i></span>
                                <span v-else-if="alerts.indexOf('email') !== -1" class="input-group-addon dangerbg" v-tooltip="'Er is een ongeldige waarde'"><i class="mdi mdi-alert-circle-outline"></i></span>
                                <span v-else class="input-group-addon" v-tooltip="'Te controleren'"><i class="mdi mdi-dots-horizontal"></i></span>
                            </div>
                            <span v-if="errors.has('email')" class="help-block">{{ errors.get('email') }}</span>
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('code')}">
                            <label for="code">Afkorting*:</label>
                            <div class="input-group">
                                <input type="text" id="code" class="form-control" tabindex="1"
                                    :disabled="add !== true"
                                    v-model="form.code"
                                    @focus="clear('code')"
                                    @blur="check('code', $event)"
                                />
                                <span v-if="checked.indexOf('code') !== -1" class="input-group-addon successbg"><i class="mdi mdi-check"></i></span>
                                <span v-else-if="alerts.indexOf('code') !== -1" class="input-group-addon dangerbg" v-tooltip="'Er is een ongeldige waarde'"><i class="mdi mdi-alert-circle-outline"></i></span>
                                <span v-else class="input-group-addon" v-tooltip="'Te controleren'"><i class="mdi mdi-dots-horizontal"></i></span>
                            </div>
                            <span v-if="errors.has('code')" class="help-block">{{ errors.get('code') }}</span>
                        </div>
                        <div
                            :class="{'form-group':true, 'has-error': errors.has('usergroup_id')}"
                            v-if="hashr && usergroups.length > 1"
                        >
                            <label for="usergroup">Gebruikersgroep*:</label>
                            <v-select id="usergroup"
                                :reduce="value => value.value"
                                :options="usergroups"
                                v-model="form.usergroup_id"
                            ></v-select>
                            <span
                                v-if="errors.has('usergroup_id')"
                                class="help-block"
                            >{{ errors.get('usergroup_id') }}</span>
                        </div>
                        <div class="form-group" v-if="form.usergroup_id !== form.contract_usergroup_id">
                            <div class="callout callout-danger">
                                <h4>Let op!</h4>
                                <p>Om de calculaties van de urenregistratie mee te veranderen naar de uurtarieven die voor de nieuwe gebruikersgroep gelden, zal er een nieuw contract aangemaakt moeten worden voor deze medewerker</p>
                            </div>
                        </div>
                        <div
                            class="form-group"
                            v-if="hashr && usergroups.length === 1"
                        >
                            <label for="usergroup">Gebruikersgroep*:</label>
                            <p class="form-control-static">{{ usergroups[0].label }}</p>
                        </div>
                        <div
                            :class="{'form-group':true, 'has-error': errors.has('team')}"
                            v-if="hashr"
                        >
                            <label for="team">Team:</label>
                            <v-select id="team"
                                  :reduce="value => value.value"
                                  :options="teams"
                                  v-model="form.team_id"
                            ></v-select>
                            <span
                                v-if="errors.has('team')"
                                class="help-block"
                            >{{ errors.get('team') }}</span>
                        </div>
                    </div>
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-spin fa-refresh"></i>
                    </div>
                </div>
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Persoonsgegevens</h2>
                    </div>
                    <div class="box-body">
                        <div :class="{'form-group':true, 'has-error': errors.has('firstname')}">
                            <label for="firstname">Voornaam*:</label>
                            <input type="text" id="firstname" class="form-control" tabindex="1" v-model="form.firstname" />
                            <span v-if="errors.has('firstname')" class="help-block">{{ errors.get('firstname') }}</span>
                        </div>
                        <div class="form-group">
                            <label for="middlename">Tussenvoegsels:</label>
                            <input type="text" id="middlename" class="form-control" tabindex="1" v-model="form.middlename" />
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('lastname')}">
                            <label for="lastname">Achternaam*:</label>
                            <input type="text" id="lastname" class="form-control" tabindex="1" v-model="form.lastname" />
                            <span v-if="errors.has('lastname')" class="help-block">{{ errors.get('lastname') }}</span>
                        </div>
                        <div class="form-group">
                            <label for="address">Adres:</label>
                            <input type="text" id="address" class="form-control" tabindex="1" v-model="form.address" />
                        </div>
                        <div class="form-group">
                            <label for="zipcode">Postcode:</label>
                            <input type="text" id="zipcode" class="form-control" tabindex="1" v-model="form.zipcode" />
                        </div>
                        <div class="form-group">
                            <label for="city">Plaats:</label>
                            <input type="text" id="city" class="form-control" tabindex="1" v-model="form.city" />
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('country')}">
                            <label for="country">Land:</label>
                            <v-select id="country"
                                :reduce="value => value.value"
                                :options="countries"
                                v-model="form.country_id"
                            ></v-select>
                            <span v-if="errors.has('country')" class="help-block">{{ errors.get('country') }}</span>
                        </div>
                    </div>
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-spin fa-refresh"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Contactgegevens</h2>
                    </div>
                    <div class="box-body">
                        <div class="form-group">
                            <label for="phone">Telefoonnummer:</label>
                            <input type="text" id="phone" class="form-control" tabindex="1" v-model="form.phone" />
                        </div>
                        <div class="form-group">
                            <label for="mobile">Mobiel:</label>
                            <input type="text" id="mobile" class="form-control" tabindex="1" v-model="form.mobile" />
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('private_email')}">
                            <label for="private_email">E-mailadres (Prive):</label>
                            <input type="text" id="private_email" class="form-control" tabindex="1" v-model="form.private_email" />
                            <span v-if="errors.has('private_email')" class="help-block">{{ errors.get('private_email') }}</span>
                        </div>
                        <div class="form-group">
                            <label for="in-case-of-emergency">{{ lang.get('global.tel_emergency') }}:</label>
                            <input type="text" id="in-case-of-emergency" class="form-control" tabindex="1" v-model="form.tel_emergency" />
                        </div>
                    </div>
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-spin fa-refresh"></i>
                    </div>
                </div>
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Overig</h2>
                    </div>
                    <div class="box-body">
                        <div class="form-group">
                            <label for="bsn">BSN:</label>
                            <input type="text" id="bsn" class="form-control" tabindex="1" v-model="form.bsn" />
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('birthday')}">
                            <label for="birthday">Geboortedatum*:</label>
                            <date-picker id="birthday" v-model="form.birthday" format="DD-MM-YYYY" type="date" lang="en"></date-picker>
                            <span v-if="errors.has('birthday')" class="help-block">{{ errors.get('birthday') }}</span>
                        </div>
                        <div class="form-group">
                            <label for="birthplace">Geboorteplaats:</label>
                            <input type="text" id="birthplace" class="form-control" tabindex="1" v-model="form.birthplace" />
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('birthcountry')}">
                            <label for="birthcountry">Geboorteland:</label>
                            <v-select id="birthcountry"
                                :reduce="value => value.value"
                                :options="countries"
                                v-model="form.birthcountry_id"
                            ></v-select>
                            <span v-if="errors.has('birthcountry')" class="help-block">{{ errors.get('birthcountry') }}</span>
                        </div>
                        <div class="form-group">
                            <label for="bank_name">Banknaam:</label>
                            <input type="text" id="bank_name" class="form-control" tabindex="1" v-model="form.bank_name" />
                        </div>
                        <div :class="{'form-group':true, 'has-error': errors.has('iban_number')}">
                            <label for="iban_number">IBAN:</label>
                            <input type="text" id="iban_number" class="form-control" tabindex="1" v-model="form.iban_number" />
                            <span v-if="errors.has('iban_number')" class="help-block">{{ errors.get('iban_number') }}</span>
                        </div>
                    </div>
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-spin fa-refresh"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Wachtwoord</h2>
                    </div>
                    <div class="box-body">
                        <div class="form-group" v-if="add === true || change.password === true">
                            <label for="password">Wachtwoord:</label>
                            <input type="password" id="password" tabindex="1" class="form-control" v-model="form.password" />
                            <span class="help-block">Een willekeurig wachtwoord: <strong v-text="randomPassword"></strong></span>
                            <button class="btn btn-primary btn-sm" v-if="!add" @click="change.password = false">Wachtwoord <u>niet</u> wijzigen</button>
                        </div>
                        <div class="form-group" v-else>
                            <button class="btn btn-primary btn-sm" @click="change.password = true">Wachtwoord wijzigen</button>
                        </div>
                    </div>
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-spin fa-refresh"></i>
                    </div>
                </div>
                <div class="text-right">
                    <button
                        class="btn btn-primary btn-sm"
                        @click="onSubmit"
                        :disabled="!canSubmit"
                    >Opslaan</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import Errors from "../../Errors";
import moment from 'moment';
import Lang from '../../Lang';
import generatePassword from '../../helpers/generatePassword';

export default {

    components: {
        vSelect,
        DatePicker,
    },

    computed: {

        canAddUser() {
            return (parseInt(this.stats.max) + this.stats.threshold) > this.stats.current ||
                this.add === false;
        },

        canSubmit() {
            return this.postData.locale_id &&
                this.postData.username &&
                this.postData.email &&
                this.postData.code &&
                this.postData.firstname &&
                this.postData.lastname &&
                this.postData.birthday &&
                this.alerts.length === 0 &&
                this.posting === false &&
                (this.add !== true || this.postData.password) &&
                (this.hashr !== true || this.postData.usergroup_id);
        },

        exceedsLimit() {
            return this.stats.current > this.stats.max;
        },

        postData() {
            let data = JSON.parse(JSON.stringify(this.form));
            data.birthday = data.birthday ? moment(data.birthday).format("YYYY-MM-DD") : null;
            if (this.add === false && this.change.password === false) {
                delete data.password;
            }
            return data;
        },

        randomPassword() {
            return generatePassword(12);
        },

    },

    data() {
        return {
            checked:[],
            alerts:[],

            add:true,
            change:{
                password:false,
            },
            countries:[],
            errors:new Errors,
            form: {
                locale_id:null,
                username:'',
                email:'',
                code:'',
                usergroup_id:null,
                team_id:null,

                firstname:'',
                middlename:'',
                lastname:'',
                address:'',
                zipcode:'',
                city:'',
                residence:'',
                country_id:null,

                phone:'',
                mobile:'',
                private_email:'',
                tel_emergency:'',

                bsn:'',
                birthday:'',
                birthplace:'',
                birthcountry_id:null,
                bank_name:'',
                iban_number:'',

                password:'',

            },
            hashr:false,
            lang:Lang,
            loading:true,
            locales:[],
            paths:[],
            posting:false,
            stats:{
                current:0,
                max:5,
                threshold:2,
            },
            teams:[],
            usergroups:[],
        }
    },

    methods: {

        check(field, event) {
            let path = '';
            let value = event.target.value;
            if (value === "") {
                return;
            }
            switch(field) {
                case 'username':path = this.paths.usernamecheck; break;
                case 'code': path = this.paths.codecheck; break;
                case 'email': path = this.paths.emailcheck; break;
                default:break;
            }
            let data = {};
            data[field] = value;
            axios.get(path, {params: data})
            .then(resp => {
                if (resp.data.status === "OK") {
                    this.checked.push(field);
                } else {
                    this.alerts.push(field);
                    let errors = {};
                    errors[field] = ["Deze waarde is in gebruik. Kies s.v.p. een andere waarde"];
                    this.errors.record(errors);
                }
            });
        },

        clear(field) {
            this.errors.clear(field);
            this.alerts = [];
        },

        getInfo() {
            axios.get(this.infoUrl)
            .then(resp => {
                this.countries = resp.data.countries;
                this.locales = resp.data.locales;
                this.paths = resp.data.paths;
                this.stats = resp.data.stats;
                if (resp.data.usergroups) {
                    this.hashr = true;
                    this.usergroups = resp.data.usergroups;
                    if (this.usergroups.length === 1) {
                        this.form.usergroup_id = this.usergroups[0].value;
                    }
                }
                if (resp.data.teams) {
                    this.teams = resp.data.teams;
                }
                if (resp.data.userdata) {
                    let userdata = resp.data.userdata;
                    userdata.birthday = moment(userdata.birthday).toDate();
                    this.add = false;
                    this.checked.push("username");
                    this.checked.push("email");
                    this.checked.push("code");
                    this.form = userdata;
                }
                this.loading = false;
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden! Probeer het later nogmaals"));
        },

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }
            this.posting = true;
            axios.post(this.postUrl, this.postData)
            .then(resp => {
                if (resp.data.success) {
                    this.$snotify.success('De gebruikersgegevens zijn verwerkt');
                    this.$emit('userChanged', resp.data.data.user_uuid);
                } else {
                    this.$snotify.error('Er is iets fout gegaan bij het verwerken van de gebruikersgegevens.');
                }
            })
            .catch(err => {
                this.errors.record(err.response.data.errors);
                this.$snotify.error("Er zijn fouten in het formulier gevonden");
            })
            .finally(() => this.posting = false);
        },

    },

    mounted() {
        this.getInfo();
    },

    props: {
        infoUrl: { required:true },
        postUrl: { required:true },
    },

}

</script>

<style>

    .dangerbg {
        background-color:#f2dede !important;
    }
    .successbg {
        background-color:#dff0d8 !important;
    }

</style>
